import { useEffect } from 'react';
import { useProfileSendAction } from 'react-easyrocket';
import { Navigate, useSearchParams } from 'react-router';
import { useRoute } from 'src/router/hooks/useRoute';

/**
 * Компонент, который ответственен за послания запроса на подтверждение email
 * Вставляется в роутер, пример <Route path={ROUTE.ACTION} element={<SendAction />} />
 */

export function EmailConfirmationHandler() {
  const [searchParams] = useSearchParams();
  const { ROUTE } = useRoute();

  const { mutate } = useProfileSendAction();

  useEffect(() => {
    const data = searchParams.get('data');

    if (data) {
      mutate({ data });
    }
  }, [mutate, searchParams]);

  return <Navigate to={ROUTE.MAIN.get()} />;
}
